import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b33260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-header" }
const _hoisted_2 = {
  key: 0,
  class: "loading-wrap"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading-dot" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "empty-wrap"
}
const _hoisted_6 = {
  key: 2,
  class: "table-wrapper"
}
const _hoisted_7 = { class: "strategy-table" }
const _hoisted_8 = { class: "col-idx" }
const _hoisted_9 = { class: "col-name" }
const _hoisted_10 = { class: "col-num" }
const _hoisted_11 = { class: "col-num" }
const _hoisted_12 = { class: "col-num" }
const _hoisted_13 = { class: "col-num" }
const _hoisted_14 = { class: "col-num" }
const _hoisted_15 = { class: "col-num" }
const _hoisted_16 = { class: "col-freq" }
const _hoisted_17 = ["onClick", "onContextmenu"]
const _hoisted_18 = { class: "col-idx" }
const _hoisted_19 = { class: "col-name" }
const _hoisted_20 = { class: "col-num" }
const _hoisted_21 = { class: "col-freq" }
const _hoisted_22 = {
  key: 0,
  class: "menu-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: "strategy-table-wrap",
    style: _normalizeStyle({
    '--st-bg':          _ctx.tableVars.panelBg,
    '--st-border':      _ctx.tableVars.panelBorder,
    '--st-header-bg':   _ctx.tableVars.headerBg,
    '--st-header-text': _ctx.tableVars.headerText,
    '--st-th-color':    _ctx.tableVars.thColor,
    '--st-text':        _ctx.tableVars.textPrimary,
    '--st-text-sub':    _ctx.tableVars.textSecondary,
    '--st-row-hover':   _ctx.tableVars.rowHover,
    '--st-row-active':  _ctx.tableVars.rowActive,
  })
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.tran('已订阅策略')), 1),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!_ctx.list.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Nodata, {
              mode: "vertical",
              customdesc: _ctx.tran('暂无订阅策略'),
              pagetheme: _ctx.isDark ? 'dark' : 'light'
            }, null, 8, ["customdesc", "pagetheme"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.tran('序')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.tran('名称')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.tran('当日涨幅')), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.tran('3日涨幅')), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.tran('5日涨幅')), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.tran('近3月收益')), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.tran('近1年收益')), 1),
                  _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.tran('最大回撤')), 1),
                  _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.tran('调仓频率')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.code,
                    class: _normalizeClass({ active: _ctx.selectedCode === item.code }),
                    onClick: ($event: any) => (_ctx.$emit('select', item)),
                    onContextmenu: _withModifiers(($event: any) => (_ctx.showContextMenu($event, item)), ["prevent"])
                  }, [
                    _createElementVNode("td", _hoisted_18, _toDisplayString(index + 1), 1),
                    _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_19, [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ])), [
                      [_directive_widthoverflowtitle, item.name]
                    ]),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-num", _ctx.pctClass(item.dayReturn)])
                    }, _toDisplayString(_ctx.formatPct(item.dayReturn)), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-num", _ctx.pctClass(item.day3Return)])
                    }, _toDisplayString(_ctx.formatPct(item.day3Return)), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-num", _ctx.pctClass(item.day5Return)])
                    }, _toDisplayString(_ctx.formatPct(item.day5Return)), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-num", _ctx.pctClass(item.month3Return)])
                    }, _toDisplayString(_ctx.formatPct(item.month3Return)), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["col-num", _ctx.pctClass(item.yearReturn)])
                    }, _toDisplayString(_ctx.formatPct(item.yearReturn)), 3),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatPcts(item.maxDrawDown)), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.holdPeriodText(item.holdPeriod)), 1)
                  ], 42, _hoisted_17))
                }), 128))
              ])
            ])
          ])),
    (_ctx.contextMenuVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "context-menu",
          style: _normalizeStyle({ left: _ctx.contextMenuX + 'px', top: _ctx.contextMenuY + 'px' })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["context-menu-item", { loading: _ctx.unsubscribeLoading }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUnsubscribe && _ctx.handleUnsubscribe(...args)))
          }, [
            (_ctx.unsubscribeLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.tran('删除订阅')), 1)
          ], 2)
        ], 4))
      : _createCommentVNode("", true)
  ], 4))
}